import {
  BlockWrapper,
  defineBlock,
  smartProps,
  useEditor,
} from "@smartfire/js-block-engine";
import { EditableHeading } from "@smartfire/components";
import { useEffect, useRef, useState } from "react";
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Navigation } from "swiper";
import { Separator } from "../components";
import Brand from "./brand";
import style from "./block.module.scss";

export const HomeBrand = ({ brands = [], title, ...props }) => {
  const { isEditing } = useEditor();
  const [displayedBrands, setDisplayedBrands] = useState([]);
  // React i18next
  const { t } = useTranslation();

  /**
   * Hook on resize
   */
  const isTablet = useMediaQuery("(max-width:" + style.tabletBreakpoint + ")");
  const isMobile = useMediaQuery("(max-width:" + style.mobileBreakpoint + ")");

  // Turn all the brands in array of many brands
  let numberOfPost = 8;
  if (isMobile) {
    numberOfPost = 5;
  } else if (isTablet) {
    numberOfPost = 7;
  }

  useEffect(() => {
    if (brands?.length > 0) {
      // Array of maximum 'numberOfPost' brands.
      const numberOfArray = Math.ceil(brands.length / numberOfPost);
      const numberOfBrandPerArray = Math.ceil(brands.length / numberOfArray);

      const chunks = Array.from({ length: numberOfArray }, (_, i) => {
        const chunk = brands.slice(
          i * numberOfBrandPerArray,
          (i + 1) * numberOfBrandPerArray
        );
        return [
          ...chunk,
          ...Array(numberOfBrandPerArray - chunk.length).fill(undefined),
        ];
      });
      setDisplayedBrands(chunks);
    }
  }, [brands, numberOfPost]);

  // Setup Swiper and initialize it with React refs
  const [swiper, setSwiper] = useState();
  const swiperNextRef = useRef(null);
  const swiperPrevRef = useRef(null);
  const swiperSettings = {
    slidesPerView: 1,
    spaceBetween: 28,
    navigation: {
      prevEl: swiperPrevRef.current,
      nextEl: swiperNextRef.current,
    },
    modules: [Navigation],
  };

  const initSwiper = (swiper) => {
    // Delay execution for the refs to be defined
    setTimeout(() => {
      // Re-init navigation
      if (swiper.params?.navigation) {
        swiper.params.navigation.prevEl = swiperPrevRef.current;
        swiper.params.navigation.nextEl = swiperNextRef.current;
        swiper.navigation.destroy();
        swiper.navigation.init();
        swiper.navigation.update();
      }
    });
  };

  return (
    <BlockWrapper.Div className={style.block}>
      <div className={style.top}>
        {(isEditing || title) && (
          <EditableHeading
            smartProp={"title"}
            placeholder={`${t("Our brands")}`}
            className={style.title}
          />
        )}
        <Separator className={style.separator} />
        {displayedBrands?.length > 1 && (
          <div className={style.navBtns}>
            <div
              ref={swiperPrevRef}
              className={style.btn}
              onClick={() => swiper?.slidePrev()}
            >
              <ArrowBackIcon />
            </div>
            <div
              ref={swiperNextRef}
              className={style.btn}
              onClick={() => swiper?.slideNext()}
            >
              <ArrowForwardIcon />
            </div>
          </div>
        )}
      </div>
      <div className={style.brands}>
        <Swiper
          {...swiperSettings}
          onSwiper={(swiper) => {
            initSwiper(swiper);
            setSwiper(swiper);
          }}
        >
          {isEditing ? (
            <div className={style.slide}>Icon of brands will be here</div>
          ) : (
            displayedBrands?.length > 0 &&
            displayedBrands.map((chunk, i) => (
              <SwiperSlide className={style.slide} key={i}>
                {chunk?.length > 0 &&
                  chunk.map((brand, j) => <Brand brand={brand} key={j} />)}
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block: HomeBrand,
  setup: {
    title: "Home Brand",
  },
  smartProps: {
    title: smartProps.object.withDefault({
      content: "",
      headingLevel: 4,
    }),
  },
});
